import React, { PropsWithChildren } from "react";
import cx from "classnames";
import EditButton from "pages/Profile/components/EditButton";
import "./styles.scss";

interface Props {
  className?: string;
  isEdit?: boolean;
  editBottom?: boolean;
  onClickEdit?: () => void;
}

const ProfileCard = ({
  children,
  className,
  isEdit,
  editBottom,
  onClickEdit,
}: PropsWithChildren<Props>) => (
  <div className={cx("profile-card", className)}>
    {isEdit && (
      <EditButton
        onClick={onClickEdit}
        className={cx("card-edit", {
          "card-edit--top": !editBottom,
          "card-edit--bottom": editBottom,
        })}
      />
    )}
    {children}
  </div>
);

export default ProfileCard;
